(function () {
  'use strict';

  if (customElements.get('pdp-tabs')) return;

  var DESKTOP_MQ = '(min-width: 1024px)';

  class PdpTabs extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-pdp-tabs-nav]');
      this.links = Array.prototype.slice.call(this.querySelectorAll('[data-pdp-tabs-link]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-pdp-tabs-panel]'));
      this.toggles = Array.prototype.slice.call(this.querySelectorAll('[data-pdp-tabs-toggle]'));

      if (!this.panels.length) return;

      this.mql = window.matchMedia(DESKTOP_MQ);
      this.isDesktop = this.mql.matches;

      this._onMqChange = this._onMqChange.bind(this);

      this.links.forEach(function (link) {
        link.addEventListener('click', this._onLinkClick.bind(this));
      }, this);
      if (this.nav) {
        this.nav.addEventListener('keydown', this._onNavKeydown.bind(this));
      }

      this.toggles.forEach(function (btn) {
        btn.addEventListener('click', this._onToggleClick.bind(this));
      }, this);

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this._onMqChange);
      } else if (this.mql.addListener) {
        this.mql.addListener(this._onMqChange);
      }

      this._setMode();
    }

    disconnectedCallback() {
      if (this.mql) {
        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this._onMqChange);
        } else if (this.mql.removeListener) {
          this.mql.removeListener(this._onMqChange);
        }
      }
    }

    _onMqChange() {
      this.isDesktop = this.mql.matches;
      this._setMode();
    }

    _defaultPanel() {
      for (var i = 0; i < this.panels.length; i++) {
        if (this.panels[i].hasAttribute('data-has-content')) return this.panels[i];
      }
      return this.panels[0];
    }

    _setMode() {
      if (this.isDesktop) {
        this.toggles.forEach(function (btn) {
          btn.setAttribute('tabindex', '-1');
        });
        var current = this._activeLink() || this._linkFor(this._defaultPanel());
        this._selectTab(current);
      } else {
        this.toggles.forEach(function (btn) {
          btn.removeAttribute('tabindex');
        });
        this._openPanel(this._defaultPanel());
      }
    }

    _onToggleClick(event) {
      if (this.isDesktop) {
        event.preventDefault();
        return;
      }
      var panel = event.currentTarget.closest('[data-pdp-tabs-panel]');
      if (panel.classList.contains('is-open')) {
        this._openPanel(null);
      } else {
        this._openPanel(panel);
      }
    }

    _openPanel(target) {
      this.panels.forEach(function (panel) {
        var open = panel === target;
        panel.classList.toggle('is-open', open);
        var btn = panel.querySelector('[data-pdp-tabs-toggle]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    _activeLink() {
      return this.links.filter(function (item) {
        return item.getAttribute('aria-current') === 'true';
      })[0];
    }

    _linkFor(panel) {
      if (!panel) return this.links[0];
      return this.links.filter(function (item) {
        return item.getAttribute('href') === '#' + panel.id;
      })[0];
    }

    _onLinkClick(event) {
      if (!this.isDesktop) return;
      event.preventDefault();
      this._selectTab(event.currentTarget);
    }

    _selectTab(link) {
      if (!link) return;
      var targetId = link.getAttribute('href').slice(1);

      this.links.forEach(function (item) {
        if (item === link) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      this.panels.forEach(function (panel) {
        var open = panel.id === targetId;
        panel.classList.toggle('is-open', open);
        var btn = panel.querySelector('[data-pdp-tabs-toggle]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    _onNavKeydown(event) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;
      var index = this.links.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();

      var next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.links.length) % this.links.length;
      if (event.key === 'ArrowRight') next = (index + 1) % this.links.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.links.length - 1;
      this.links[next].focus();
      this._selectTab(this.links[next]);
    }
  }

  customElements.define('pdp-tabs', PdpTabs);
})();
